<div class="px-2">
  <div class="form-row row">
    <div class="col-2">
      <label class="control-label">{{'i18n.domain.administration.tariff-details.zone-tab.assigned-zones' | translate}}:</label>
    </div>
    <div class="col-10">
      @for (zone of assignedZones; track zone) {
        <div class="assigned-zones">
          <div>{{zone.name}}</div>
        </div>
      }
    </div>
  </div>
</div>
